import { Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from './contexts/auth'
import { PermissionsProvider } from './contexts/permissions'
import { ProtectedRoute } from './components/ProtectedRoute'
import { Layout } from './components/Layout'
import { LoginPage } from './pages/LoginPage'
import { DashboardPage } from './pages/DashboardPage'
import { ClientsPage } from './pages/ClientsPage'
import { ProductsPage } from './pages/ProductsPage'
import { StockPage } from './pages/StockPage'
import { PosicaoEstoquePage } from './pages/PosicaoEstoquePage'
import { InboundPage } from './pages/InboundPage'
import { RecebimentoPaletesPage } from './pages/RecebimentoPaletesPage'
import { InboundDetailPage } from './pages/InboundDetailPage'
import { OutboundPage } from './pages/OutboundPage'
import { OutboundDetailPage } from './pages/OutboundDetailPage'
import { BillingPage } from './pages/BillingPage'
import { UsersPage } from './pages/UsersPage'
import { WarehousesPage } from './pages/WarehousesPage'
import { LotsPage } from './pages/LotsPage'
import { TransfersPage } from './pages/TransfersPage'
import { TransferDetailPage } from './pages/TransferDetailPage'
import { PalletsPage } from './pages/PalletsPage'
import { PackingListPage } from './pages/PackingListPage'
import { LocationsPage } from './pages/LocationsPage'
import { AdjustmentsPage } from './pages/AdjustmentsPage'
import { IntegrationsPage } from './pages/IntegrationsPage'
import { PickingPage } from './pages/PickingPage'
import { PickingWaveDetailPage } from './pages/PickingWaveDetailPage'
import { CockpitPage } from './pages/CockpitPage'
import { OrdersPage } from './pages/OrdersPage'
import { ExpeditionBoardPage } from './pages/ExpeditionBoardPage'
import { ExpedirScanPage } from './pages/ExpedirScanPage'
import { ContagemPage } from './pages/ContagemPage'
import { ContagemMobilePage } from './pages/ContagemMobilePage'
import { ConferenciaArmazemPage } from './pages/ConferenciaArmazemPage'
import { BaixaSeparacaoPage } from './pages/BaixaSeparacaoPage'
import { AbastecimentoPage } from './pages/AbastecimentoPage'
import { RastreioLotePage } from './pages/RastreioLotePage'
import { DivergenciasPage } from './pages/DivergenciasPage'
import { DefeitoPage } from './pages/DefeitoPage'
import { EnviosClientePage } from './pages/EnviosClientePage'
import { SeparacaoArquivoPage } from './pages/SeparacaoArquivoPage'
import { MovimentacoesPage } from './pages/MovimentacoesPage'
import { PermissionsPage } from './pages/PermissionsPage'
import { AuditPage } from './pages/AuditPage'
import { IndustriaMateriaisPage } from './pages/IndustriaMateriaisPage'
import { IndustriaMaterialDetailPage } from './pages/IndustriaMaterialDetailPage'
import { IndustriaRecebimentoPage } from './pages/IndustriaRecebimentoPage'
import { IndustriaEtiquetasPage } from './pages/IndustriaEtiquetasPage'
import { IndustriaFichasPage } from './pages/IndustriaFichasPage'
import { IndustriaOpsPage } from './pages/IndustriaOpsPage'
import { IndustriaOpDetailPage } from './pages/IndustriaOpDetailPage'
import { IndustriaApontamentoPage } from './pages/IndustriaApontamentoPage'
import { IndustriaRastreabilidadePage } from './pages/IndustriaRastreabilidadePage'
import { IndustriaComprasPage } from './pages/IndustriaComprasPage'
import { IndustriaCompraDetailPage } from './pages/IndustriaCompraDetailPage'
import { IndustriaFornecedoresPage } from './pages/IndustriaFornecedoresPage'
import { IndustriaPagarPage } from './pages/IndustriaPagarPage'
import { IndustriaSolicitacoesPage } from './pages/IndustriaSolicitacoesPage'
import { MinhaProducaoPage } from './pages/MinhaProducaoPage'
import { IndustriaEmbalagemPage } from './pages/IndustriaEmbalagemPage'
import { IndustriaSimuladorPage } from './pages/IndustriaSimuladorPage'
import { IndustriaFaturamentoPage } from './pages/IndustriaFaturamentoPage'

export default function App() {
  return (
    <AuthProvider>
      <PermissionsProvider>
      <Routes>
        <Route path="/login" element={<LoginPage />} />

        <Route
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route path="/" element={<DashboardPage />} />
          <Route path="/clients" element={<ClientsPage />} />
          <Route path="/products" element={<ProductsPage />} />
          <Route path="/stock" element={<StockPage />} />
          <Route path="/posicao-estoque" element={<PosicaoEstoquePage />} />
          <Route path="/inbound" element={<InboundPage />} />
          <Route path="/recebimento-paletes" element={<RecebimentoPaletesPage />} />
          <Route path="/inbound/:id" element={<InboundDetailPage />} />
          <Route path="/outbound" element={<OutboundPage />} />
          <Route path="/outbound/:id" element={<OutboundDetailPage />} />
          <Route path="/billing" element={<BillingPage />} />
          <Route path="/users" element={<UsersPage />} />
          <Route path="/warehouses" element={<WarehousesPage />} />
          <Route path="/lots" element={<LotsPage />} />
          <Route path="/transfers" element={<TransfersPage />} />
          <Route path="/transfers/:id" element={<TransferDetailPage />} />
          <Route path="/pallets" element={<PalletsPage />} />
          <Route path="/locations" element={<LocationsPage />} />
          <Route path="/adjustments" element={<AdjustmentsPage />} />
          <Route path="/integrations" element={<IntegrationsPage />} />
          <Route path="/picking" element={<PickingPage />} />
          <Route path="/picking/:id" element={<PickingWaveDetailPage />} />
          <Route path="/cockpit" element={<CockpitPage />} />
          <Route path="/orders" element={<OrdersPage />} />
          <Route path="/despachar" element={<ExpeditionBoardPage />} />
          <Route path="/expedir" element={<ExpedirScanPage />} />
          <Route path="/contagem" element={<ContagemPage />} />
          <Route path="/contagem-mobile" element={<ContagemMobilePage forceMode="count" />} />
          <Route path="/conferencia" element={<ContagemMobilePage forceMode="conference" />} />
          <Route path="/conferencia-fracionamento" element={<ContagemMobilePage forceMode="conference" scope="fracionamento" />} />
          <Route path="/conferencia-armazem" element={<ConferenciaArmazemPage />} />
          <Route path="/packing-list" element={<PackingListPage />} />
          <Route path="/baixa-separacao" element={<BaixaSeparacaoPage />} />
          <Route path="/abastecimento" element={<AbastecimentoPage />} />
          <Route path="/rastreio-lote" element={<RastreioLotePage />} />
          <Route path="/divergencias" element={<DivergenciasPage />} />
          <Route path="/defeito" element={<DefeitoPage />} />
          <Route path="/meus-envios" element={<EnviosClientePage />} />
          <Route path="/separacao-arquivo" element={<SeparacaoArquivoPage />} />
          <Route path="/movimentacoes" element={<MovimentacoesPage />} />
          <Route path="/industria/materiais" element={<IndustriaMateriaisPage />} />
          <Route path="/industria/materiais/:id" element={<IndustriaMaterialDetailPage />} />
          <Route path="/industria/recebimento" element={<IndustriaRecebimentoPage />} />
          <Route path="/industria/etiquetas" element={<IndustriaEtiquetasPage />} />
          <Route path="/industria/fichas" element={<IndustriaFichasPage />} />
          <Route path="/industria/simulador" element={<IndustriaSimuladorPage />} />
          <Route path="/industria/ops" element={<IndustriaOpsPage />} />
          <Route path="/industria/ops/:id" element={<IndustriaOpDetailPage />} />
          <Route path="/industria/apontamento" element={<IndustriaApontamentoPage />} />
          <Route path="/industria/rastreabilidade" element={<IndustriaRastreabilidadePage />} />
          <Route path="/industria/compras" element={<IndustriaComprasPage />} />
          <Route path="/industria/compras/:id" element={<IndustriaCompraDetailPage />} />
          <Route path="/industria/fornecedores" element={<IndustriaFornecedoresPage />} />
          <Route path="/industria/pagar" element={<IndustriaPagarPage />} />
          <Route path="/industria/faturamento" element={<IndustriaFaturamentoPage />} />
          <Route path="/industria/solicitacoes" element={<IndustriaSolicitacoesPage />} />
          <Route path="/industria/embalagem" element={<IndustriaEmbalagemPage />} />
          <Route path="/minha-producao" element={<MinhaProducaoPage />} />
          <Route path="/permissions" element={<PermissionsPage />} />
          <Route path="/auditoria" element={<AuditPage />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      </PermissionsProvider>
    </AuthProvider>
  )
}
